import { ref } from 'vue'

/**
 * Composable pour la prévisualisation de PDF de devis
 * Limite: 30 lignes max
 */
export function useQuotePDFPreview(quoteId, quote) {
  const showPDFPreview = ref(false)
  const pdfPreviewUrl = ref('')

  const openPreview = (url) => {
    pdfPreviewUrl.value = url
    showPDFPreview.value = true
  }

  const closePDFPreview = () => {
    if (pdfPreviewUrl.value) {
      window.URL.revokeObjectURL(pdfPreviewUrl.value)
      pdfPreviewUrl.value = ''
    }
    showPDFPreview.value = false
  }

  const downloadPDF = () => {
    if (!pdfPreviewUrl.value) return
    
    const displayId = quote.value?.human_id || quote.value?.humanId || quoteId
    const a = document.createElement('a')
    a.href = pdfPreviewUrl.value
    a.download = `devis-${displayId}.pdf`
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  }

  return {
    showPDFPreview,
    pdfPreviewUrl,
    openPreview,
    closePDFPreview,
    downloadPDF
  }
}
